import {IActivities} from "@/apps/MyStudyChoiceActivitiesWidget/models/activities-viewmodel";

export function sortActivityByDate(activities: IActivities): IActivities {
    return activities.sort((a, b) => {
            return new Date(a.eventStartDate).getTime() - new Date(b.eventStartDate).getTime();
        }
    )
}

export function isBetweenDates({today, from, to}: { today: Date, from: string, to: string }): boolean {
    return (today.getTime() > new Date(from).getTime() && today.getTime() < new Date(to).getTime())
}
